import { render, staticRenderFns } from "./customer-price-group.vue?vue&type=template&id=2e66d8dc"
import script from "./customer-price-group.vue?vue&type=script&lang=js"
export * from "./customer-price-group.vue?vue&type=script&lang=js"
import style0 from "./customer-price-group.vue?vue&type=style&index=0&id=2e66d8dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports